import { useEffect, useRef } from "react";
/* USEUPDATEEFFECT FUNCIONA CUANDO TENEMOS UNA CONDICIÓN Y NO QUEREMOS QUE SE LANZE EL USEEFFECT EN EL PRIMER RENDER -> VALOR INICIAL */

export default function useUpdateEffect(callback, dependencies) {
  const firstRenderRef = useRef(true);

  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }
    return callback();
  }, dependencies);
}
